<div class="officePreview">
  @if (!this.externalUrlSet) {
    <div class="borderless">
      <p>Loading preview...</p>
    </div>
  }
  @if (this.externalUrlSet) {
    <div class="borderless">
      <iframe class="officeFilePreviewExternalContent" [src]="this.externalUrlSafe"></iframe>
    </div>
  }
</div>